module.controller(
    'regulationAnalysisListCtrl',
    [ '$scope', '$rootScope', '$state', 'regulationService', 'alertService', 'ASEBIOL_CONSTANTS',
        function($scope, $rootScope, $state, regulationService, alertService, ASEBIOL_CONSTANTS) {

    		$scope.idRegulation = $state.params.idRegulation;
            $scope.analysis = [];
            $scope.analysisValue = [];
            $scope.loading = false;
            $scope.valueActive = false;
            $scope.filter = {};
            $scope.pagination = {
                    current : 1,
                    total : 0
                };
            
            $scope.technique = {
        			MinAmountUnits : {},
        			ResultTypeUnits : {},
        			resulttype : null,
        			presenceAbsenceLimit : false,
        			dilutions: {}
        		};
            
            $scope.varShowHide = false;
            $scope.varShowHideValue = false;
            $scope.analysisSelected=[];
            
            $scope.CNT = ASEBIOL_CONSTANTS;

            /**
             *
             * @param idUser
             */
            
           
            $scope.search = function(page) {
                $scope.loading = true;
                
                page = page == undefined ? 1 : page;
                $scope.pagination.current = page;

                var filter = {};
                filter.offset = (page - 1) * $rootScope.pageSize;
                filter.limit = $rootScope.pageSize;
                filter.visible = $scope.filter.visible;

                if($scope.filter.name){
                    filter.name = $scope.filter.name;
                }
                
                regulationService.searchAnalysis($scope.idRegulation, filter).then(function(response) {
                    $scope.loading = false;
                    var result = response.getData();
                    $scope.analysis = result.results;
                    if($scope.analysis.length >0){
                        $scope.valueActive = true;
                    }else
                	{
                    	$scope.valueActive = false;
            		}
                
                    $scope.pagination.total = result.totalRegisters;
                }, function(response) {
                    $scope.loading = false;
                });
            };

            $scope.changeAnalysisState = function(idAnalysis, state){
            	if(state){
            		regulationService.enableAnalysis($scope.idRegulation,idAnalysis).then(function(response) {
            			$scope.loading = false;
            			alertService.showSuccess('Análisis activo nuevamente en el sistema');
            		}, function(response) {
            			$scope.loading = false;	
            		}); 
            	}
            	else{
            		regulationService.disableAnalysis($scope.idRegulation,idAnalysis).then(function(response) {
            			$scope.loading = false;
            			alertService.showSuccess('Análisis inactivo');
            		}, function(response) {
            			
            			$scope.loading = false;
            		}); 
            	}
            };
            
            $scope.addAnalysisInRegulation = function(){
                alertService.showSwtQuestion('Agregar Análisis a normativa', function() {
        				
                	var createModel = {
                        	idRegulation: $scope.idRegulation,
                        	idsAnalysis:[],
                        	
                        	dilution : $scope.technique.dilution,
                        	resultType : $scope.technique.resulttype[0].enumName,
            				upperRange : $scope.technique.upperRange,
            				lowerRange : $scope.technique.lowerRange,
            				upperLimit : $scope.technique.upperLimit,
            				lowerLimit : $scope.technique.lowerLimit,
            				minAmount : $scope.technique.minAmount,
            				idMinAmountUnits : $scope.technique.MinAmountUnits.selected[0].id,
            				dilutions : $scope.technique.dilutions.selected,
            				numTubes: $scope.technique.numTubes
                    };
                	
        			if($scope.technique.presenceAbsenceLimit == false){
        				createModel.presenceAbsenceLimit = PRESENCE_ABSENCE_LIMIT.ABSENCE.enumName;
        			}
        			else if($scope.technique.presenceAbsenceLimit == true){
        				createModel.presenceAbsenceLimit = PRESENCE_ABSENCE_LIMIT.PRESENCE.enumName;
        			}
        			
        			if ($scope.technique.ResultTypeUnits && $scope.technique.ResultTypeUnits.selected)
        				createModel.idResultTypeUnits = $scope.technique.ResultTypeUnits.selected[0].id;
        			
                	var items = $scope.analysisSelected.selected;
                	if(items){
                    	createModel.idsAnalysis = createModel.idsAnalysis.concat(items.map(function(item){return item.id}));
                    }
                    regulationService.addAnalysisInRegulation(createModel).then(function(response) {
                        $scope.loading = false;
                        alertService.showSuccess('Análisis añadido satisfactoriamente');
                        
                        $scope.technique = {
                    			MinAmountUnits : {},
                    			ResultTypeUnits : {},
                    			resultType : null,
                    			presenceAbsenceLimit : false,
                    			dilutions: {}
                    		};
                        
                        $scope.varShowHide = false;
                        $scope.varShowHideValue = false;
                        
                        $scope.search(1);
                    }, function(response) {
                        $scope.loading = false;
                    });
                	
                });
            	
            }
            
            $scope.remove= function(idRegulation, idAnalysis){
            	var a = $scope.analysis.find(function(a){ return a.id == idAnalysis; })
                alertService.showSwtQuestion('Eliminar análisis "'+ a.name +'"', function() {
                    $scope.loading = true;

                    regulationService.removeRegulationAnalysis(idRegulation,idAnalysis).then(function(response) {
                        $scope.loading = false;
                        $scope.search(1);
                        alertService.showSuccess('Análisis eliminado de la normativa satisfactoriamente');
                    }, function(response) {
                        $scope.loading = false;
                    });
                });
            };
            
            
            /*Obtener los valores de la normativa para agregarlos*/
            
            $scope.getNameType = function(m){
            	var txtInfo = '';
            	if(m.resulttype == 'PRESENT_LACK'){}
            	else if(m.resulttype == 'RANGE'){
            		txtInfo = m.lowerRange + '-' + m.lowerRange;
            	}
            	if(txtInfo == ''){
            		return getConstantNameById(eval('TECHNIQUE_TYPE'), m.resulttype);
            	}
            	return getConstantNameById(eval('TECHNIQUE_TYPE'), m.resulttype)+' (' + txtInfo+")";
            };
            
            
        	$scope.addTechniqueInRegulation = function() {
        		alertService.showSwtQuestion('Agregar valores a la normativa', function() {

        			regulationService.addValuesInRegulation($scope.idRegulation, $scope.idAnalysis, tech.id ,createModel).then(function(response) {
        				$scope.loading = false;
        				alertService.showSuccess('Valores añadidos satisfactoriamente');
        				 $scope.search(1);
        				$scope.ShowHide();
        			}, function(response) {
        				$scope.loading = false;
        			});
        		});
        	};
        	
        	$scope.checkUncertainty = function(data) {
        		var regVal = $scope.CNT.REGEX_3DECIMAl.test(data);
        		if (!regVal) {
        			return "Debe ser un número positivo \r\n y máximo 3 decimales";
        		}
        	};
            
            $scope.clearFilters = function(){
            	$scope.filter = {};
            };
            
            $scope.search(1);
            
            $scope.ShowHide = function(){
                $scope.varShowHide =! $scope.varShowHide;
            }
            
            $scope.ShowHideValue = function(){
                $scope.varShowHideValue =! $scope.varShowHideValue;
            }
            
            /*----------- Funcion para buscar los resultados de la normativa ------------*/
            
            
            $scope.loadUpdateValues = function (idAnalysis) {
            	$scope.ShowHideValue();
            	$scope.ShowHide();
                  		
            	$scope.loading = true;
            		

            		regulationService.getValuesRegulation($scope.idRegulation, idAnalysis).then(function(response) {
            			$scope.loading = false;

            			var responseData = response.getData();
            			
            			/* Se usa este objeto para reutilizar parametros pero hace referencia al analysis*/
            			
            			$scope.technique = {
            				name : responseData.name,
            				dilution : responseData.dilutions,
            				resulttype : responseData.resulttype,
            				upperRange : responseData.upperRange,
            				lowerRange : responseData.lowerRange,
            				upperLimit : responseData.upperLimit,
            				lowerLimit : responseData.lowerLimit,
            				description : responseData.description,
            				minAmount : responseData.minAmount,
            				active : responseData.active,
            				sigla : responseData.sigla,
            				MinAmountUnits : {
            					selected : [ {
            						id : responseData.minAmountUnits.id,
            						name : responseData.minAmountUnits.name,
            						value : responseData.minAmountUnits.value,
            						category : responseData.minAmountUnits.category,
            						parent : responseData.minAmountUnits.parent,
            						type : responseData.minAmountUnits.type
            					} ]
            				},
            				samplingMethods : responseData.samplingMethods,
            				dilutions : {
            					selected : responseData.dilutions
            				},
            				numTubes: responseData.numTubes
            			};
            			$scope.analysisValue.name = $scope.technique.name;
            			$scope.analysisValue.id = responseData.id;
            			if (responseData.resultTypeUnits) {
            				$scope.technique.ResultTypeUnits = {
            					selected : [ {
            						id : responseData.resultTypeUnits.id,
            						name : responseData.resultTypeUnits.name,
            						value : responseData.resultTypeUnits.value,
            						category : responseData.resultTypeUnits.category,
            						parent : responseData.resultTypeUnits.parent,
            						type : responseData.resultTypeUnits.type
            					} ]
            				}
            			}

            			if(responseData.presenceAbsenceLimit){
            				if(responseData.presenceAbsenceLimit == PRESENCE_ABSENCE_LIMIT.PRESENCE.enumName){
            					$scope.technique.presenceAbsenceLimit = true;	
            				}
            				else if(responseData.presenceAbsenceLimit == PRESENCE_ABSENCE_LIMIT.ABSENCE.enumName){
            					$scope.technique.presenceAbsenceLimit = false;
            				}
            			}
            			
            			$scope.technique.resulttype = [ getConstantById(eval('TECHNIQUE_TYPE'), $scope.technique.resulttype) ];

            		}, function(response) {
            			$scope.loading = false;
            		});
	
			}
            
        	/**
        	 * 
        	 */
        	$scope.updateValues = function(idAnalysis) {
        		alertService.showSwtQuestion('Actualizar valores en la normativa', function() {
        			$scope.loading = true;

                    
        			var updateModel = {
        				name : $scope.analysisValue.name,
        				dilutions : $scope.technique.dilutions,
        				resulttype : $scope.technique.resulttype[0].enumName,
        				upperRange : $scope.technique.upperRange,
        				lowerRange : $scope.technique.lowerRange,
        				upperLimit : $scope.technique.upperLimit,
        				lowerLimit : $scope.technique.lowerLimit,
        				description : $scope.technique.description,
        				minAmount : $scope.technique.minAmount,
        				idMinAmountUnits : $scope.technique.MinAmountUnits.selected[0].id,
        				dilutions : $scope.technique.dilutions.selected,
        				sigla : $scope.technique.sigla,
        		     	numTubes: $scope.technique.numTubes
        			
        			};
        			if($scope.idTypeResult){
        				updateModel.idTypeResult = $scope.idTypeResult;
        			}
        			
        			if($scope.technique.presenceAbsenceLimit == false){
        				updateModel.presenceAbsenceLimit = PRESENCE_ABSENCE_LIMIT.ABSENCE.enumName;
        			}
        			else if($scope.technique.presenceAbsenceLimit == true){
        				updateModel.presenceAbsenceLimit = PRESENCE_ABSENCE_LIMIT.PRESENCE.enumName;
        			}

        			if ($scope.technique.ResultTypeUnits && $scope.technique.ResultTypeUnits.selected){
        				updateModel.idResultTypeUnits = $scope.technique.ResultTypeUnits.selected[0].id;
        			}

        			regulationService.updateValues($scope.idRegulation,idAnalysis, updateModel).then(function(response) {
        				$scope.loading = false;
        				alertService.showSuccess('Valores actualizados satisfactoriamente');
        			}, function(response) {
        				$scope.loading = false;
        			});
        		});
        	};
            
        } ]);


